import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../../components/Layout';
import LotteryCodeField from '../../components/LotteryCodeField';
import DateField from '../../components/DateField';
import { fetchWinningNumberReport } from '../../api/winningNumbers';
import { todayISO } from '../../utils/date';
import './ReportWinningNumbersPage.css';

// Rapports > Winning Numbers — branche sur le backend le 2026-10-12 (etait une
// maquette : resultats ecrits en dur, From/To sans effet). Numeros gagnants
// applicables a la company sur la periode (override company sinon global), cf.
// tirages/views.py:WinningNumberReportView.

// YYYY-MM-DD -> DD/MM/YYYY (meme affichage que l'ancienne maquette).
const fmtDate = (iso) => {
  const [y, m, d] = String(iso).split('-');
  return d && m && y ? `${d}/${m}/${y}` : iso;
};

const keysOf = (row) => [
  { label: 'NUM', value: row.numbers },
  { label: 'WIN4', value: row.win4 },
  { label: '1er', value: row.t1 || '--' },
  { label: '2e', value: row.t2 || '--' },
  { label: '3e', value: row.t3 || '--' },
];

const ReportWinningNumbersPage = () => {
  const [lottery, setLottery] = useState('0');
  const [lotteryName, setLotteryName] = useState('');
  const [dateFrom, setDateFrom] = useState(todayISO());
  const [dateTo, setDateTo] = useState(todayISO());
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [searched, setSearched] = useState(false);

  const search = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const data = await fetchWinningNumberReport({ dateFrom, dateTo, tirage: lottery });
      setRows(data.rows || []);
    } catch (err) {
      let msg = 'Recherche impossible.';
      try {
        const p = JSON.parse(err.message);
        if (p?.detail) msg = p.detail;
      } catch (_) { /* noop */ }
      setRows([]);
      setError(msg);
    } finally {
      setLoading(false);
      setSearched(true);
    }
  }, [dateFrom, dateTo, lottery]);

  // Premiere ouverture : resultats du jour, comme avant (sans attendre Search).
  useEffect(() => { search(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleSearch = (e) => {
    e.preventDefault();
    search();
  };

  return (
    <Layout>
      <p className="rwn-breadcrumb">
        Ruta : <Link to="/dashboard" className="bc-link">Menu</Link>
        {' >> '}
        <Link to="/rapports" className="bc-link">Reports</Link>
        {' >> '}
        <span className="bc-current">Winning Numbers</span>
      </p>

      <div className="rwn-card">
        <div className="rwn-card-header">
          <span className="rwn-card-title">Winning Numbers</span>
        </div>
        <div className="rwn-card-body">
          <form onSubmit={handleSearch} className="rwn-form">
            <div className="rwn-row">
              <label className="rwn-label">Lottery</label>
              <LotteryCodeField
                value={lottery}
                name={lotteryName}
                onChange={setLottery}
                onResolve={(code, name) => { setLottery(code); setLotteryName(name); }}
                inputClass="rwn-input rwn-input-sm"
                iconClass="rwn-icon-btn"
                nameClass="rwn-lottery-name"
              />
            </div>

            <div className="rwn-row">
              <label className="rwn-label">From</label>
              <DateField className="rwn-input rwn-input-date" value={dateFrom} onChange={setDateFrom} />

              <label className="rwn-label rwn-label-to">To</label>
              <DateField className="rwn-input rwn-input-date" value={dateTo} onChange={setDateTo} />
            </div>

            <button type="submit" className="rwn-search-btn" disabled={loading}>
              {loading ? 'Recherche...' : 'Search'}
            </button>
          </form>
        </div>
      </div>

      {error && <p className="rwn-error">{error}</p>}

      {searched && !error && (
        <div className="rwn-card">
          <div className="rwn-card-header">
            <span className="rwn-card-title">Results ({rows.length})</span>
          </div>
          <div className="rwn-card-body rwn-results-body">
            <table className="rwn-table">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Lottery</th>
                  <th>User</th>
                  <th>Key</th>
                </tr>
              </thead>
              <tbody>
                {rows.length === 0 && (
                  <tr><td colSpan={4} className="rwn-empty">Aucun numero gagnant sur cette periode.</td></tr>
                )}
                {rows.map((row) => {
                  const keys = keysOf(row);
                  return (
                    <React.Fragment key={`${row.date}-${row.tirage_code}`}>
                      <tr>
                        <td rowSpan={2}>{fmtDate(row.date)}</td>
                        <td rowSpan={2}>{row.tirage_code} - {row.tirage_name}</td>
                        <td rowSpan={2}>{row.user}</td>
                        <td>
                          <div className="rwn-key-row">
                            {keys.map((k) => <span key={k.label} className="rwn-key-label">{k.label}</span>)}
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div className="rwn-key-row">
                            {keys.map((k) => <span key={k.label} className="rwn-key-value">{k.value}</span>)}
                          </div>
                        </td>
                      </tr>
                    </React.Fragment>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </Layout>
  );
};

export default ReportWinningNumbersPage;
